
import { useState } from 'react'
import G from '../images/sett.png'
import D from './Settings.module.css'
import F from './ListDam.module.css';
import { TabContext, TabList, TabPanel } from '@material-ui/lab';
import { Box, Tab } from '@mui/material';
import CattleStatusList from '../Components/Setting/CattleStatusList';
import { KeyboardBackspace } from '@mui/icons-material';
import { Link } from 'react-router-dom';



const MainSettings=()=>{
  const [Value,setValue]=useState("1")

    const handleChange = (event, newValue) => {
        setValue(newValue);
      };

return <>
<div className={D.Settingcontainer}>
<div style={{display:'flex',flexDirection:"column",width:'100%'}}>
      <div className='d-flex justify-content-between align-items-center'>
      <div className={F.AllAnimalssTitleLICon}>
        <img className={F.AllAnimalssIconimgLITit} style={{width:'70px',height:'70px'}} src={G}/>
        <h2> تنظیمات</h2>
        </div>
        <Link to='/AllFarmsAdmin'  className='backButton' >
          <KeyboardBackspace fontSize='large'/>
        </Link>
      </div>
        <hr/>

        <div>
        {/* <div onClick={openD} data-title='افزودن کاربر جدید' className={`${F.CreateNewFarmBtn}`}>
                <AddCircleOutlineIcon/>
        </div> */}
        {/* <div className={`${F.CreateNewFarmBtn}`} onClick={openModallTime}>
                 <AddAlarmIcon/>
                    
                    
                              
                       

                </div> */}
            <TabContext value={Value}>
  <Box  style={{direction:'rtl',marginBottom:'-20px',marginRight:'10px',padding:'0px 8px'}}>
    <TabList variant="scrollable" scrollButtons="auto" onChange={handleChange} aria-label="lab API tabs example">
      <Tab label="وضعیت دام" value="1" />
      <Tab label="وضعیت سنسور"    value="2" />
      <Tab label="چرخه زندگی دام" value="3" />
      <Tab label="یادداشت دام"    value="4" />
      <Tab label="یادداشت سنسور"    value="5" />
      <Tab label="ترتیب چرخه زندگی" value="6" />
      <Tab label='انواع بهاربند' value="7"/>
      <Tab label='یادداشت بهاربند' value="8"/>
      <Tab label='یادداشت دامداری' value="9"/>
    </TabList>
  </Box>
  <hr style={{marginTop:'18px'}}/>
  <TabPanel value="1" style={{padding:'35px 0px'}}>
  <CattleStatusList flag={1}/>
  </TabPanel>
  <TabPanel value="2" style={{padding:'35px 0px'}}>
  <CattleStatusList flag={2}/>
  </TabPanel>
  <TabPanel value="3" style={{padding:'35px 0px'}}>
  <CattleStatusList flag={3}/>
  </TabPanel>
  <TabPanel value="4" style={{padding:'35px 0px'}}>
  <CattleStatusList flag={4}/>
  </TabPanel>
  <TabPanel value="5" style={{padding:'35px 0px'}}>
  <CattleStatusList flag={5}/>
  </TabPanel>
  <TabPanel value="6" style={{padding:'35px 0px'}}>
  <CattleStatusList flag={6}/>
  </TabPanel>
  <TabPanel value="7" style={{padding:'35px 0px'}}>
  <CattleStatusList flag={7}/>
  </TabPanel>
  <TabPanel value="8" style={{padding:'35px 0px'}}>
  <CattleStatusList flag={8}/>
  </TabPanel>
  <TabPanel value="9" style={{padding:'35px 0px'}}>
  <CattleStatusList flag={9}/>
  </TabPanel>
  </TabContext>
        </div>
      </div>

</div>

</>
}
export default MainSettings